import { render, staticRenderFns } from "./DescargarPlanoPdf.vue?vue&type=template&id=18d93976"
import script from "./DescargarPlanoPdf.vue?vue&type=script&lang=js"
export * from "./DescargarPlanoPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports